/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IPriceVisualizationData } from './price-visualization.data';
import { IPriceVisualizationProps } from './price-visualization.props.autogenerated';

export interface IPriceVisualizationViewProps extends IPriceVisualizationProps<IPriceVisualizationData> {}

class PriceVisualization extends React.PureComponent<IPriceVisualizationProps<IPriceVisualizationData>> {
    private static USER_COOKIE_NAME_CONST = 'price-exhibition';

    public static getCookieName() {
        return PriceVisualization.USER_COOKIE_NAME_CONST;
    }

    /**
     * Helper method to set price exhibition cookie for user session
     * @param value Boolean specifying which value we're setting
     */
    public setPriceExhibitionCookie(value: boolean) {
        this.props.context.request.cookies.set(PriceVisualization.USER_COOKIE_NAME_CONST, value);
    }

    public async getPriceExhibitionValue() {
        if (
            this.props.app.config.priceExhibition &&
            this.props.context.request.cookies.isConsentGiven() &&
            //@ts-ignore
            this.props.context.request.User
        ) {
            const cookieValue = this.props.context.request.cookies.get(PriceVisualization.USER_COOKIE_NAME_CONST);
            const isAuthenticated = this.props.context.request.user.isAuthenticated;
            if (isAuthenticated && !cookieValue) {
                this.setPriceExhibitionCookie(this.props.app.config.priceExhibitionDefault ?? false);
                window.location.reload();
            } else if (!isAuthenticated) {
                this.setPriceExhibitionCookie(false);
            }
        }
    }

    public render(): JSX.Element | null {
        this.getPriceExhibitionValue();
        return this.props.renderView(this.props);
    }
}

export default PriceVisualization;
